
import Vue from 'vue';
import AdminSvgIcon from '@/assets/icons/Admin.svg';
import AlertsSvgIcon from '@/assets/icons/Alerts.svg';
import EnergySvgIcon from '@/assets/icons/Energy.svg';
import DashboardSvgIcon from '@/assets/icons/Dashboard.svg';
import RulesSvgIcon from '@/assets/icons/Rules.svg';
import ReportsSvgIcon from '@/assets/icons/Reports.svg';
import DevicesMapSvgIcon from '@/assets/icons/Devices_map.svg';
import DevicesSvgIcon from '@/assets/icons/Devices.svg';
import RoomsSvgIcon from '@/assets/icons/Rooms.svg';
import NotificationsSvgIcon from '@/assets/icons/Notifications.svg';

export default Vue.extend({
	components: {
		AdminSvgIcon,
		AlertsSvgIcon,
		EnergySvgIcon,
		DashboardSvgIcon,
		RulesSvgIcon,
		DevicesSvgIcon,
		DevicesMapSvgIcon,
		RoomsSvgIcon,
		NotificationsSvgIcon,
		ReportsSvgIcon,
	},
	props: {
		currentRouteName: String,
		sideBarVisible: { type: Boolean, default: true },
		userPermission: { type: Boolean, default: true },
		backgroundColor: { type: String, default: 'bg-secondary' },
		borderColor: { type: String, default: 'border-secondary' },
	},
	methods: {
		navigation(routeName: string) {
			this.$emit('navigation', routeName);
		},
	},
});
